import moment from 'moment';
import { createContext, useContext, useEffect, useState } from 'react';
import { getLoanVehicleUsage, LoanVehicleSearch, postLoanVehicleUsage } from '../../../Core/Service/loanVehicleUsage-service';
import AppContext from '../../../App/AppContext';
import { t } from 'i18next';

export const LoanVehicleContext = createContext();

export const LoanVehicleProvider = (props) => {
    let HeaderRecordID = props?.match?.params?.HeaderRecordID || props?.HeaderRecordID || null;

    const urlParams = new URLSearchParams(props.location?.search?.toLowerCase());

    const navigateToDashboard = urlParams?.get('navigate') === 'true';
    const LoanVehicleUsageID = urlParams?.get('loanvehicleusageid') || props?.LoanVehicleUsageID || null;

    const FUEL_OPTIONS = [
        { id: 0, name: 'Empty' },
        { id: 0.25, name: 'Quarter' },
        { id: 0.5, name: 'Half' },
        { id: 0.75, name: 'Three Quarter' },
        { id: 1, name: 'Full' }
    ];

    const [state, setState] = useState({
        handoverCustomerSignatureOut: '',
        handoverStaffSignatureOut: '',
        handoverCustomerSignatureIn: '',
        handoverStaffSignatureIn: '',
        loading: false,
        loanVehicleList: [],
        isVehicleInState: false,
        isUpdate: false,
        isVehicleReceived: false,
        fuelOutDrpown: FUEL_OPTIONS,
        selectedFuelOut: null,
        regNumberValue: {},
        openTc: false,
        LoanAnotherVehicle: false,
        vehicleIsReturned: false
    });
    const [companyDetails, setCompanyDetails] = useState({
        companyContactName: '',
        companyContactEmail: '',
        companyContactCompany: '',
        companyContactNumber: '',
        companyContactAddress: '',
        companyContactPostCode: '',
        companyContactReasonForUse: '',
        companyDriverName: '',
        companyRegistrationNumber: '',
        companyWIPNumber: null
    });

    const [loading, setLoading] = useState(false);

    const { showToast } = useContext(AppContext);

    const [bookingDetails, setBookingDetails] = useState({
        dateOut: null,
        dateIn: null,
        estimatedDateDueIn: null,
        mileageOut: null,
        mileageIn: null,
        fuelOut: null,
        fuelIn: null,
        loanVehicleUsageInsuranceUploaded: false
    });

    const [handOverDetails, setHandOverDetails] = useState({
        handedOverName: '',
        handoverCustomerSignatureOut: '',
        handoverStaffSignatureOut: '',
        handoverCustomerSignatureIn: '',
        handoverStaffSignatureIn: ''
    });

    const [loanVehicleInImages, setLoanVehicleInImages] = useState([]);
    const [loanVehicleOutImages, setLoanVehicleOutImages] = useState([]);

    const [vehicleDetails, setVehicleDetails] = useState({
        dateCreated: moment().format('YYYY-MM-DD'),
        vehicleModel: '',
        insuranceValue: null,
        loanVehicleList: [],
        vehicleReg: '',
        tempLoanVehicle: []
    });

    const [errors, setErrors] = useState({});

    const handleFuelSelect = (selectedOption) => {
        setState((prev) => ({
            ...prev,
            selectedFuelOut: selectedOption
        }));

        if (selectedOption) {
            setErrors((prev) => ({ ...prev, fuelOut: null }));
        }
        setBookingDetails((prev) => ({
            ...prev,
            fuelOut: selectedOption ? selectedOption.id : null
        }));
    };
    const handleFuelLevelInSelect = (selectedOption) => {
        setState((prev) => ({
            ...prev,
            selectedFuelLevelFuelIn: selectedOption
        }));

        if (selectedOption) {
            setErrors((prev) => ({ ...prev, fuelIn: null }));
        }
        setBookingDetails((prev) => ({
            ...prev,
            fuelIn: selectedOption ? selectedOption.id : null
        }));
    };

    const handleVehicleDetails = (e) => {
        const { name, value } = e.target;
        setVehicleDetails({ ...vehicleDetails, [name]: value });
        setState((prev) => ({ ...prev, isUpdate: true }));
    };

    const handleCompanyContactDetails = (e) => {
        const { name, value } = e.target;
        setCompanyDetails({ ...companyDetails, [name]: value });
    };

    const handleBookingDetails = (e) => {
        const { name, value } = e.target;
        setBookingDetails({ ...bookingDetails, [name]: value });
        validateMileage(name, value);
    };
    const handleHandOverDetails = (e) => {
        const { name, value } = e.target;
        setHandOverDetails({ ...handOverDetails, [name]: value });
    };

    const fieldChange = (val) => {
        setHandOverDetails((st) => ({
            ...st,
            ...val
        }));
    };

    const clearSig = (name) => {
        setHandOverDetails((st) => ({
            ...st,
            [name]: null
        }));
    };

    const createNewLVU = () => {
        setVehicleDetails((prev) => ({
            ...prev,
            vehicleModel: '',
            insuranceValue: '',
            vehicleReg: '',
            loanVehicleID: '',
            dateCreated: moment().format('YYYY-MM-DD'),
            loanVehicleUsageID: ''
        }));

        setBookingDetails((prev) => ({
            ...prev,
            dateOut: moment().format('YYYY-MM-DDTHH:mm'),
            dateIn: '',
            estimatedDateDueIn: '',
            mileageOut: '',
            mileageIn: '',
            fuelOut: '',
            fuelIn: '',
            loanVehicleUsageInsuranceUploaded: false
        }));

        setHandOverDetails((prev) => ({
            ...prev,
            handedOverName: '',
            handoverCustomerSignatureOut: '',
            handoverStaffSignatureOut: '',
            handoverCustomerSignatureIn: '',
            handoverStaffSignatureIn: ''
        }));

        setLoanVehicleOutImages([]);
        setLoanVehicleInImages([]);

        setState((prev) => ({
            ...prev,
            error: null,
            // isVehicleInState: !!(data.handoverCustomerSignatureOut && data.handoverStaffSignatureOut),
            // isVehicleReceived: !!(data.handoverCustomerReturnSignature && data.handoverStaffReturnSignature),
            isVehicleInState: false,
            isVehicleReceived: false,
            selectedFuelOut: '',
            selectedFuelLevelFuelIn: '',
            regNumberValue: null,
            isCustomerSignatureOut: '',
            isStaffSignatureOut: '',
            isCustomerSignatureIn: '',
            isStaffSignatureIn: '',
            LoanAnotherVehicle: true,
            vehicleIsReturned: false
        }));
    };

    useEffect(() => {
        let isMounted = true;

        const searchLoanVehicle = async () => {
            try {
                const res = await LoanVehicleSearch('');

                if (!res?.success) {
                    console.error('LoanVehicleSearch failed:', res?.message || 'Unknown error');
                    return;
                }

                const list = res?.data?.list;
                if (isMounted && Array.isArray(list) && list.length > 0) {
                    const mappedList = list.map((k) => ({
                        ...k,
                        name: k.regNo,
                        id: k.regNo
                    }));

                    setVehicleDetails((prev) => ({
                        ...prev,
                        loanVehicleList: list,
                        tempLoanVehicle: mappedList
                    }));
                }
            } catch (error) {
                console.error('Error fetching loan vehicles:', error);
            }
        };

        searchLoanVehicle();

        return () => {
            isMounted = false;
        };
    }, []);

    const singleSelectChange = (event, val) => {
        try {
            if (!val) {
                // if user clears selection
                setState((prev) => ({ ...prev, regNumberValue: null }));
                setVehicleDetails((prev) => ({
                    ...prev,
                    loanVehicleID: null,
                    vehicleReg: '',
                    vehicleModel: ''
                }));
                return;
            }

            // ✅ Process the selected value
            getRegNumber(val);

            // ✅ Store selected value in state
            setState((prev) => ({
                ...prev,
                regNumberValue: val
            }));
        } catch (error) {
            console.error('Error handling single select change:', error);
        }
    };

    const getRegNumber = (obj) => {
        try {
            if (!obj) return;

            if (obj.headerRecordID && obj.workflowID) {
                const newPath = `/Job/${obj.headerRecordID}/${obj.workflowID}?ProcessId=1`;
                const url = `${window.location.origin}${newPath}`;
                window.open(url, '_blank', 'noopener,noreferrer');
            }

            setVehicleDetails((prev) => ({
                ...prev,
                loanVehicleID: obj?.loanVehicleID ?? null, // fixed typo & safer with ??
                vehicleReg: obj?.regNo ?? '',
                vehicleModel: obj?.vehicleModel ?? ''
            }));
        } catch (error) {
            console.error('Error processing vehicle selection:', error, obj);
        }
    };

    const handleCancel = () => {
        props.onClose ? props.onClose(true) : window.top.postMessage({ type: navigateToDashboard ? 'navigate-dashboard' : 'close-modal-and-refresh' }, '*');
    };

    const fetchData = async () => {
        setState((prev) => ({ ...prev, loading: true, error: null }));

        try {
            const res = await getLoanVehicleUsage(LoanVehicleUsageID, HeaderRecordID);

            if (!res?.success) {
                throw new Error('Failed to fetch loan vehicle data');
            }

            const data = res?.data?.detail?.[0] ?? {};

            const formatDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : '');
            const formatDateTime = (date) => (date ? moment(date).format('YYYY-MM-DDTHH:mm') : '');

            setCompanyDetails((prev) => ({
                ...prev,
                companyContactName: data.companyContactName ?? '',
                companyContactEmail: data.companyContactEmail ?? '',
                companyContactCompany: data.companyContactCompany ?? '',
                companyContactNumber: data.companyContactNumber ?? '',
                companyContactAddress: data.companyContactAddress ?? '',
                companyContactPostCode: data.companyContactPostCode ?? '',
                companyContactReasonForUse: data.companyContactReasonForUse ?? '',
                companyDriverName: data.companyDriverName ?? '',
                companyRegistrationNumber: data.companyRegistrationNumber ?? '',
                companyWIPNumber: data.companyWIPNumber ?? ''
            }));

            setVehicleDetails((prev) => ({
                ...prev,
                vehicleModel: data.vehicleModel ?? '',
                insuranceValue: data.insuranceValue ?? '',
                vehicleReg: data.registrationNumber ?? '',
                loanVehicleID: data.loanVehicleID ?? '',
                dateCreated: formatDate(data.dateCreated),
                loanVehicleUsageID: data.loanVehicleUsageID ?? ''
            }));

            setBookingDetails((prev) => ({
                ...prev,
                dateOut: formatDateTime(data.dateOut),
                dateIn: formatDateTime(data.dateIn),
                estimatedDateDueIn: formatDateTime(data.estimatedDateDueIn),
                mileageOut: data.mileageOut ?? '',
                mileageIn: data.mileageIn ?? '',
                fuelOut: data.fuelOut ?? '',
                fuelIn: data.fuelIn ?? '',
                loanVehicleUsageInsuranceUploaded: data.loanVehicleUsageInsuranceUploaded ?? false
            }));

            setHandOverDetails((prev) => ({
                ...prev,
                handedOverName: data.handedOverName ?? '',
                handoverCustomerSignatureOut: data.handoverCustomerSignatureOut ?? '',
                handoverStaffSignatureOut: data.handoverStaffSignatureOut ?? '',
                handoverCustomerSignatureIn: data.handoverCustomerReturnSignature ?? '',
                handoverStaffSignatureIn: data.handoverStaffReturnSignature ?? ''
            }));

            setLoanVehicleOutImages(res?.data?.loanVehicleOutImages?.map((i) => i.outVehicleImage) ?? []);
            setLoanVehicleInImages(res?.data?.loanVehicleInImages?.map((i) => i.inVehicleImage) ?? []);

            const fuelOption = FUEL_OPTIONS.find((opt) => opt.id === data.fuelOut) ?? null;
            const fuelInOption = FUEL_OPTIONS.find((opt) => opt.id === data.fuelIn) ?? null;

            setState((prev) => ({
                ...prev,
                error: null,
                // isVehicleInState: !!(data.handoverCustomerSignatureOut && data.handoverStaffSignatureOut),
                // isVehicleReceived: !!(data.handoverCustomerReturnSignature && data.handoverStaffReturnSignature),
                isVehicleInState: data.handoverCustomerSignatureOut && data.handoverStaffSignatureOut ? true : false,
                isVehicleReceived: data.handoverCustomerReturnSignature && data.handoverStaffReturnSignature ? true : false,
                selectedFuelOut: fuelOption,
                selectedFuelLevelFuelIn: fuelInOption,
                regNumberValue: data.registrationNumber ? { id: data.registrationNumber, name: data.registrationNumber } : null,
                isCustomerSignatureOut: data.handoverCustomerSignatureOut ?? '',
                isStaffSignatureOut: data.handoverStaffSignatureOut ?? '',
                isCustomerSignatureIn: data.handoverCustomerReturnSignature ?? '',
                isStaffSignatureIn: data.handoverStaffReturnSignature ?? ''
            }));
        } catch (error) {
            console.error('Error fetching loan vehicle data:', error);

            setState((prev) => ({
                ...prev,
                error: error.message ?? 'Unknown error',
                isVehicleInState: false,
                isVehicleReceived: false
            }));
        } finally {
            // ✅ Always executed
            setState((prev) => ({ ...prev, loading: false }));
        }
    };

    useEffect(() => {
        // if (!LoanVehicleUsageID) return;

        fetchData();
    }, [LoanVehicleUsageID]);

    const [isoutSignatureompleted, setIsOutSignatureCompleted] = useState(false);
    const [isInSignatureCompleted, setIsInSignatureCompleted] = useState(false);

    useEffect(() => {
        if (state.isCustomerSignatureOut && state.isStaffSignatureOut) {
            setIsOutSignatureCompleted(true);
        } else {
            setIsOutSignatureCompleted(false);
        }
    }, [state.isCustomerSignatureOut, state.isStaffSignatureOut]);

    useEffect(() => {
        if (state.isCustomerSignatureIn && state.isStaffSignatureIn) {
            setIsInSignatureCompleted(true);
        } else {
            setIsInSignatureCompleted(false);
        }
    }, [state.isCustomerSignatureIn, state.isStaffSignatureIn]);

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleInImageUpload = async (event) => {
        const files = Array.from(event.target.files);

        const newImages = await Promise.all(
            files.map(async (file) => {
                const base64 = await convertToBase64(file);
                return {
                    file,
                    preview: URL.createObjectURL(file),
                    base64: base64
                };
            })
        );

        setLoanVehicleInImages((prev) => [...prev, ...newImages]);
    };

    const handleInRemoveImage = (indexToRemove) => {
        setLoanVehicleInImages((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const handleOutImageUpload = async (event) => {
        const files = Array.from(event.target.files);

        const newImages = await Promise.all(
            files.map(async (file) => {
                const base64 = await convertToBase64(file);
                return {
                    file,
                    preview: URL.createObjectURL(file),
                    base64: base64
                };
            })
        );

        setLoanVehicleOutImages((prev) => [...prev, ...newImages]);
    };

    const handleOutRemoveImage = (indexToRemove) => {
        setLoanVehicleOutImages((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const validateMileage = (name, value) => {
        if (name === 'mileageIn' && value !== '') {
            const mileageOut = Number(bookingDetails.mileageOut);
            const mileageIn = Number(value);

            if (mileageIn < mileageOut) {
                setErrors((prev) => ({
                    ...prev,
                    mileageIn: 'Mileage In must be greater than Mileage Out'
                }));
            } else {
                setErrors((prev) => ({
                    ...prev,
                    mileageIn: null
                }));
            }
        }
    };

    const validateForm = () => {
        let errors = {};
        let isValid = true;
        if (!vehicleDetails.vehicleReg) {
            errors.vehicleReg = 'Vehicle Reg is required';
            isValid = false;
        }
        if (!vehicleDetails.vehicleModel) {
            errors.vehicleModel = 'Vehicle Model is required';
            isValid = false;
        }
        if (!vehicleDetails.dateCreated) {
            errors.dateCreated = 'Date is required';
            isValid = false;
        }
        console.log('state.selectedFuelOut', state.selectedFuelOut);
        if (!state.selectedFuelOut?.id) {
            if (state.selectedFuelOut?.id !== 0) {
                // Allow 0 as a valid value
                errors.selectedFuelOut = 'Fuel Out is required';
                isValid = false;
            }
        }
        setErrors(errors);
        return isValid;
    };

    const validateVehicleIn = () => {
        let errors = {};
        let isValid = true;
        if (!vehicleDetails.vehicleReg) {
            errors.vehicleReg = 'Vehicle Reg is required';
            isValid = false;
        }
        if (!vehicleDetails.vehicleModel) {
            errors.vehicleModel = 'Vehicle Model is required';
            isValid = false;
        }
        if (!vehicleDetails.dateCreated) {
            errors.dateCreated = 'Date is required';
            isValid = false;
        }
        if (!companyDetails.companyContactName) {
            errors.companyContactName = 'Company Name is required';
            isValid = false;
        }
        if (!companyDetails.companyContactCompany) {
            errors.companyContactCompany = ' Company is required';
            isValid = false;
        }
        if (!companyDetails.companyContactAddress) {
            errors.companyContactAddress = 'Address is required';
            isValid = false;
        }
        if (!companyDetails.companyDriverName) {
            errors.companyDriverName = 'Driver Name is required';
            isValid = false;
        }
        if (!companyDetails.companyRegistrationNumber) {
            errors.companyRegistrationNumber = 'Registration Number is required';
            isValid = false;
        }
        if (!companyDetails.companyWIPNumber) {
            errors.companyWIPNumber = 'WIP Number is required';
            isValid = false;
        }

        if (!bookingDetails.dateIn) {
            errors.dateIn = 'Date In is required';
            isValid = false;
        }

        if (!bookingDetails.mileageIn) {
            errors.mileageIn = 'Mileage In is required';
            isValid = false;
        }
        // if (!bookingDetails.fuelIn) {
        //     errors.fuelIn = 'Fuel In is required';
        //     isValid = false;
        // }
        if (!bookingDetails.fuelIn) {
            console.log(bookingDetails.fuelIn);
            if (bookingDetails.fuelIn !== 0) {
                // Allow 0 as a valid value
                errors.fuelIn = 'Fuel Out is required';
                isValid = false;
            }
        }
        // if (!bookingDetails.loanVehicleUsageInsuranceUploaded) {
        //     errors.loanVehicleUsageInsuranceUploaded = 'This Field is required';
        //     isValid = false;
        // }

        if (!handOverDetails.handoverCustomerSignatureIn) {
            errors.handoverCustomerSignatureIn = 'Customer Signature is required';
            isValid = false;
        }
        if (!handOverDetails.handoverStaffSignatureIn) {
            errors.handoverStaffSignatureIn = 'Staff Signature is required';
            isValid = false;
        }

        setErrors(errors);
        return isValid;
    };

    const validateVehicleOut = () => {
        let errors = {};
        const currentBooking = bookingDetails;

        let isValid = true;
        if (!vehicleDetails.vehicleReg) {
            errors.vehicleReg = 'Vehicle Reg is required';
            isValid = false;
        }
        if (!vehicleDetails.vehicleModel) {
            errors.vehicleModel = 'Vehicle Model is required';
            isValid = false;
        }
        if (!vehicleDetails.dateCreated) {
            errors.dateCreated = 'Date is required';
            isValid = false;
        }
        if (!companyDetails.companyContactName) {
            errors.companyContactName = 'Company Name is required';
            isValid = false;
        }
        if (!companyDetails.companyContactCompany) {
            errors.companyContactCompany = ' Company is required';
            isValid = false;
        }
        if (!companyDetails.companyContactAddress) {
            errors.companyContactAddress = 'Address is required';
            isValid = false;
        }
        if (!companyDetails.companyDriverName) {
            errors.companyDriverName = 'Driver Name is required';
            isValid = false;
        }
        if (!companyDetails.companyRegistrationNumber) {
            errors.companyRegistrationNumber = 'Registration Number is required';
            isValid = false;
        }
        if (!companyDetails.companyWIPNumber) {
            errors.companyWIPNumber = 'WIP Number is required';
            isValid = false;
        }

        if (!bookingDetails.dateOut) {
            errors.dateOut = 'Date Out is required';
            isValid = false;
        }
        if (!bookingDetails.mileageOut) {
            errors.mileageOut = 'Mileage Out is required';
            isValid = false;
        }
        if (!currentBooking.fuelOut && currentBooking.fuelOut == 0) {
            errors.fuelOut = 'Fuel Out is required';
            isValid = false;
        }

        if (!handOverDetails.handoverCustomerSignatureOut) {
            errors.handoverCustomerSignatureOut = 'Customer Signature is required';
            isValid = false;
        }
        if (!handOverDetails.handoverStaffSignatureOut) {
            errors.handoverStaffSignatureOut = 'Staff Signature is required';
            isValid = false;
        }

        setErrors(errors);
        return isValid;
    };

    const handleSave = async () => {
        if (validateForm()) {
            handleSubmit();
        }
    };

    const handleSaveOut = async () => {
        if (validateVehicleOut()) {
            handleSubmit();
        }
    };

    const handleSaveIn = async () => {
        if (validateVehicleIn() && validateVehicleOut()) {
            handleSubmit();
        }
    };

    const handleYesNo = (name, value) => {
        setBookingDetails((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const parseErrors = (errorObj) => {
        const errorMessages = [];

        // Validation / model state errors
        if (errorObj?.errors) {
            Object.entries(errorObj.errors).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    value.forEach((msg) => errorMessages.push(`${key}: ${msg}`));
                } else {
                    errorMessages.push(`${key}: ${value}`);
                }
            });
            return errorMessages;
        }

        // API sends message as string
        if (typeof errorObj?.message === 'string') {
            return [errorObj.message];
        }

        // API sends message as array
        if (Array.isArray(errorObj?.message)) {
            return errorObj.message;
        }

        // Axios / network error
        if (errorObj?.response?.data?.message) {
            return [errorObj.response.data.message];
        }

        return ['An unknown error occurred.'];
    };

    const handleSubmit = async () => {
        // try {
        setLoading(true);

        const payload = {
            headerRecordID: HeaderRecordID,
            dateCreated: vehicleDetails.dateCreated ? moment(vehicleDetails.dateCreated).format('YYYY-MM-DD') : '',
            loanVehicleID: vehicleDetails.loanVehicleID,
            loanVehicleUsageID: vehicleDetails.loanVehicleUsageID,
            registrationNumber: vehicleDetails.vehicleReg,
            insuranceValue: vehicleDetails.insuranceValue,
            dateOut: bookingDetails.dateOut ? moment(bookingDetails.dateOut).format('YYYY-MM-DDTHH:mm') : '',
            companyContactName: companyDetails.companyContactName,
            companyContactEmail: companyDetails.companyContactEmail,
            companyContactCompany: companyDetails.companyContactCompany,
            companyContactNumber: companyDetails.companyContactNumber,
            companyContactAddress: companyDetails.companyContactAddress,
            companyContactPostCode: companyDetails.companyContactPostCode,
            companyContactReasonForUse: companyDetails.companyContactReasonForUse,
            companyDriverName: companyDetails.companyDriverName,
            companyRegistrationNumber: companyDetails.companyRegistrationNumber,
            companyWIPNumber: companyDetails.companyWIPNumber,
            vehicleModel: vehicleDetails.vehicleModel,
            dateIn: bookingDetails.dateIn ? moment(bookingDetails.dateIn).format('YYYY-MM-DDTHH:mm') : '',
            mileageOut: bookingDetails.mileageOut,
            mileageIn: bookingDetails.mileageIn,
            fuelOut: bookingDetails.fuelOut,
            fuelIn: bookingDetails.fuelIn,
            loanVehicleUsageInsuranceUploaded: bookingDetails.loanVehicleUsageInsuranceUploaded,
            estimatedDateDueIn: bookingDetails.estimatedDateDueIn,
            handedOverName: handOverDetails.handedOverName,
            handoverCustomerSignatureOut: handOverDetails.handoverCustomerSignatureOut,
            handoverStaffSignatureOut: handOverDetails.handoverStaffSignatureOut,
            handoverCustomerReturnSignature: handOverDetails.handoverCustomerSignatureIn,
            handoverStaffReturnSignature: handOverDetails.handoverStaffSignatureIn,
            loanVehicleInImages: loanVehicleInImages.filter((img) => img.base64).map((img) => img.base64),
            loanVehicleOutImages: loanVehicleOutImages.filter((img) => img.base64).map((img) => img.base64),
            LoanAnotherVehicle: state.LoanAnotherVehicle
        };

        const response = await postLoanVehicleUsage(payload);

        if (response?.success) {
            showToast(response.message);
            handleCancel();
            props?.onClose && props.onClose(true);
        } else {
            console.log('Error response:', response);
            const errorMessages = response.data.message ? response.data.message : response.message ? response.message : parseErrors(response);
            errorMessages.map((msg, index) => showToast(msg));

            setLoading(false);
        }
        // } 
        // catch (error) {
        //     showToast('Error submitting loan vehicle form');
        //     setLoading(false);
        //     throw error;
        // }
    };

    const handleTc = () => {
        setState((prev) => ({
            ...prev,
            openTc: !prev.openTc
        }));
    };

    return (
        <LoanVehicleContext.Provider
            value={{
                companyDetails,
                handleCompanyContactDetails,
                bookingDetails,
                handleBookingDetails,
                handOverDetails,
                fieldChange,
                clearSig,
                state,
                handleHandOverDetails,
                vehicleDetails,
                handleVehicleDetails,
                handleInImageUpload,
                handleInRemoveImage,
                loanVehicleInImages,
                loanVehicleOutImages,
                handleOutImageUpload,
                handleOutRemoveImage,
                handleSubmit,
                // searchLoanVehicle,
                createNewLVU,
                handleCancel,
                loading,
                errors,
                handleSave,
                handleSaveOut,
                handleSaveIn,
                handleYesNo,
                handleFuelSelect,
                handleFuelLevelInSelect,
                singleSelectChange,
                handleTc,
                isoutSignatureompleted,
                isInSignatureCompleted
            }}
        >
            {props.children}
        </LoanVehicleContext.Provider>
    );
};
